import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  roundMultiplierList: [],
  totalCount: 0,
  userRoundMultiplierList: [],
  userRoundMultiplierTotalCount: 0,
};

const slice = createSlice({
  name: "RoundMultipler",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Round Multiplier
    builder.addCase(Act.getRoundMultiplierList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getRoundMultiplierList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        roundMultiplierList: payload.data,
        totalCount: payload.totalcount,
      }),
    );
    builder.addCase(Act.getRoundMultiplierList.rejected, (state, action) => ({
      ...state,
      loading: false,
      roundMultiplierList: [],
      totalCount: 0,
    }));

    //Add Round Multiplier
    builder.addCase(Act.addRoundMultiplierApi.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.addRoundMultiplierApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        RoundMultiplierList: [payload.data, ...state.RoundMultiplierList],
        totalCount: state.totalCount + 1,
      }),
    );
    builder.addCase(Act.addRoundMultiplierApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    //Edit Round Multiplier
    builder.addCase(Act.editRoundMultiplierApi.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editRoundMultiplierApi.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        RoundMultiplierList: state.RoundMultiplierList.map((item) =>
          item?._id === payload?.data?._id ? payload?.data : item,
        ),
      }),
    );
    builder.addCase(Act.editRoundMultiplierApi.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    //Delete Round Multiplier
    builder.addCase(Act.deleteRoundMultiplier.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.deleteRoundMultiplier.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        RoundMultiplierList: state.RoundMultiplierList.filter(
          (item) => item?._id !== payload?.data?._id,
        ),
        totalCount: state.totalCount > 1 ? state.totalCount - 1 : 0,
      }),
    );
    builder.addCase(Act.deleteRoundMultiplier.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));

    // Get User Round Multiplier
    builder.addCase(
      Act.getUserRoundMultiplierList.pending,
      (state, action) => ({
        ...state,
        loading: true,
      }),
    );
    builder.addCase(
      Act.getUserRoundMultiplierList.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        userRoundMultiplierList: payload.data,
        userRoundMultiplierTotalCount: payload.totalcount,
      }),
    );
    builder.addCase(
      Act.getUserRoundMultiplierList.rejected,
      (state, action) => ({
        ...state,
        loading: false,
        userRoundMultiplierList: [],
        userRoundMultiplierTotalCount: 0,
      }),
    );
  },
});

export default slice;
